import { render, staticRenderFns } from "./TopicInfo.vue?vue&type=template&id=7db80d7f&scoped=true&"
import script from "./TopicInfo.vue?vue&type=script&lang=js&"
export * from "./TopicInfo.vue?vue&type=script&lang=js&"
import style0 from "./TopicInfo.vue?vue&type=style&index=0&id=7db80d7f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db80d7f",
  null
  
)

export default component.exports